<!-- this shows the attachments of a mail
component used in EmailSearchArchives.vue and EmailTemplateArchives.vue
In (UI) Your Archives-> Inbox-> open any mail-> click attachments button
        Organization-> Email Search-> open any mail-> click attachments button
-->
<template>
  <x-dialog
    width="50%"
    :dialogTitle="dialogTitle"
    :dialogState="downloadAttachIsOpen"
    @toggleModal="val => (downloadAttachIsOpen = val)"
    :dataTestId="dataTestId"
    :actions="{
      show: !emptyArray,
      secondaryButtonFunction: closeDialog,
      primaryButtonFunction: downloadFile,
      primaryButtonShow: true,
      primaryButtonDisabled: !attachmentId.length,
      secondaryButtonText: 'Cancel',
      primaryButtonText: `Download (${attachmentId.length})`
    }"
  >
    <template slot="dialog_data">
      <loader v-if="contentLoading" />

      <v-card-text flat class="py-12 file-data-container">
        <div v-if="emptyArray">
          <b :data-test-id="`${dataTestId}__no-attachment-text`">
            There is no attachement in the email.
          </b>
        </div>
        <div v-else>
          <v-row class="file-head">
            <v-checkbox
              v-model="checkboxAll"
              label="File name"
              class="ma-0 white--text"
              color="#fff"
              flat
              :data-test-id="`${dataTestId}__select-all-box`"
              @click.native="selectAll"
            ></v-checkbox>
          </v-row>
          <div
            class="file-list"
            :data-test-id="`${dataTestId}__attachments-list`"
          >
            <v-row
              v-for="(value, key, index) in attachList"
              :key="key"
              class="file-data"
              :class="{ 'grey lighten-5': index % 2 !== 0 }"
            >
              <v-checkbox
                :label="value"
                :value="key"
                class="ma-0"
                v-model="attachmentId"
                @click.native="select"
              ></v-checkbox>
            </v-row>
          </div>
        </div>
      </v-card-text>
    </template>
  </x-dialog>
</template>

<script>
import EventBus from '@/EventBus';
import DownloadService from '@/services/DownloadService';
export default {
  props: ['attachmentList'],
  data() {
    return {
      downloadAttachIsOpen: false,
      dialogTitle: 'Attachments',
      attachList: [],
      checkboxAll: false,
      emptyArray: false,
      attachmentId: [],
      archiveId: '',
      contentLoading: false,
      dataTestId: 'email-attachments-modal'
    };
  },
  created: function() {
    document.addEventListener('keyup', this.escapeKeyListener);
  },
  destroyed: function() {
    document.removeEventListener('keyup', this.escapeKeyListener);
  },
  mounted() {
    EventBus.$on('OPEN_DIALOGUE', val => {
      this.downloadAttachIsOpen = val;
    });
  },
  watch: {
    attachmentList: [
      {
        handler: 'listAttachments'
      }
    ]
  },
  methods: {
    // escape key listener to close dialog when open
    escapeKeyListener: function(evt) {
      if (evt.keyCode === this.escapeKeyCode && this.downloadAttachIsOpen) {
        this.closeDialog();
      }
    },
    /**
     * get the attachments list
     * @param {Object} list
     */
    listAttachments(list) {
      if (Object.keys(list).length > 0) {
        this.attachList = list;
      } else {
        this.emptyArray = true;
      }
    },
    // to close dialog
    closeDialog() {
      this.attachmentId = [];
      this.checkboxAll = false;
      this.downloadAttachIsOpen = false;
    },
    // to download attachment
    async downloadFile() {
      this.contentLoading = true;
      try {
        let response = await DownloadService.downloadFile(
          this.$route.params.archiveId,
          this.attachmentId,
          this.currentlySelectedOrgId
        );
        if (response) {
          DownloadService.downloadZipFile(response);
          this.contentLoading = false;
        } else {
          this.contentLoading = false;
          this.snackbar('error', this.$message.ERROR_DOWNLOADING_FILE);
        }
        this.closeDialog();
      } catch (err) {
        this.contentLoading = false;
        this.snackbar('error', err);
      }
    },
    // select all the attachments
    selectAll() {
      this.attachmentId = [];
      if (this.checkboxAll) {
        this.attachmentId = Object.keys(this.attachList);
      } else {
        this.select();
      }
    },
    // select an attachment
    select() {
      if (this.attachmentId.length === Object.keys(this.attachList).length) {
        this.checkboxAll = true;
      } else {
        this.checkboxAll = false;
      }
    }
  },
  beforeDestroy() {
    EventBus.$off('OPEN_DIALOGUE');
  }
};
</script>

<style>
.file-head {
  background-color: #1b2342;
  color: #fff;
  padding: 8px 13px;
  font-size: 17px;
  font-weight: 600;
}
.file-head input[type='checkbox'],
.file-head label {
  color: #fff !important;
}
.file-data {
  padding: 8px 13px;
  font-size: 17px;
  font-weight: 600;
}
</style>
